import { render, staticRenderFns } from "./Latestnews.vue?vue&type=template&id=01e6b337&scoped=true&"
import script from "./Latestnews.vue?vue&type=script&lang=js&"
export * from "./Latestnews.vue?vue&type=script&lang=js&"
import style0 from "./Latestnews.vue?vue&type=style&index=0&id=01e6b337&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6b337",
  null
  
)

export default component.exports